<template>
  <div class="container__mc-explore-detail">
    <div v-if="mc.level_type" class="text-primary font-weight-bold mb-2 text-mc-type">
      <span class="mr-1"><img :src="renderedMctypeIcon" style="height: 16px" /> </span>
      <span class="text__mc-type">{{
        mc.level_type === 'CAREER_SPECIFIC' ? 'Career Specific' : 'Academic Focused'
      }}</span>
    </div>
    <vue-show-more-text
      class="text__mc-name text__title text-mc-name p-0 text-black"
      :lines="limitTitleLine"
      :text="mc.name"
      :has-more="false"
    ></vue-show-more-text>

    <vue-show-more-text
      class="text__mc-description text__description text-mc-description pt-2 h-100 p-0"
      :lines="limitDescriptionLine"
      :text="renderedDescription"
      more-text=""
      additional-content-css="font-size:16px;"
      additional-anchor-css="color: var(--primary); padding-top: 0px;padding: 0px; position: absolute;"
      @click="onClick"
    ></vue-show-more-text>
  </div>
</template>
<script>
import vueShowMoreText from 'vue-show-more-text';
export default {
  components: {
    vueShowMoreText
  },
  props: {
    mc: {
      type: Object,
      default: () => ({})
    },
    limitTitleLine: {
      type: Number,
      default: 3
    },
    limitDescriptionLine: {
      type: Number,
      default: 5
    }
  },

  computed: {
    renderedDescription() {
      const sanitizedText = this.$sanitize(this.mc.description, {});

      const plainText = sanitizedText.replace(/<[^>]*>/g, '');

      return plainText;
    },
    renderedMctypeIcon() {
      if (!this.mc || !this.mc.level_type) return null;
      return this.mc.level_type === 'CAREER_SPECIFIC'
        ? require('@/assets/learning-unit-types/specific.svg')
        : require('@/assets/learning-unit-types/academic.svg');
    }
  },

  methods: {
    onClick(event) {
      event.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
.mcName {
  text-overflow: ellipsis;
}

.text {
  &__mc-name {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
  }

  &__mc-description {
    font-weight: 400;
    font-size: 16px;

    color: rgba(7, 9, 25, 0.5);
  }
}
@media (max-width: 765px) {
  .text-mc-name {
    font-size: 14px;
  }
  .text-mc-description {
    font-size: 12px;
  }
  .text-mc-type {
    display: none;
  }
}
</style>
